import { render, staticRenderFns } from "./TopicHeader.vue?vue&type=template&id=80754e12&scoped=true"
import script from "./TopicHeader.vue?vue&type=script&lang=js"
export * from "./TopicHeader.vue?vue&type=script&lang=js"
import style0 from "./TopicHeader.vue?vue&type=style&index=0&id=80754e12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80754e12",
  null
  
)

export default component.exports